export function TagList({ tags }: { tags: string[] }) {
  if (tags.length === 0) {
    return null;
  }

  return (
    <ul aria-label="Tags" className="flex flex-wrap gap-1.5">
      {tags.map((tag) => (
        <li
          className="rounded-full bg-muted px-2.5 py-0.5 text-xs font-medium text-muted-foreground"
          key={tag}
        >
          {tag}
        </li>
      ))}
    </ul>
  );
}
